import { getRgObjectsOfType as g, RG_TYPE as l } from "@project-rouge/rg-core";
import { getPolygonArea as r } from "../../../geometry-utils/core/index14.js";
import { getBuildingProjectionPolygon as c } from "../../../geometry-utils/internal/index3.js";
const u = (e) => {
  let t = 0;
  const i = g(e, l.Building);
  for (const o of i)
    if (o.data.groundProjectionPolygon)
      t += r(o.data.groundProjectionPolygon);
    else {
      const n = c(o);
      o.data.groundProjectionPolygon = n, t += r(n);
    }
  return t;
};
export {
  u as getProjectionArea
};
//# sourceMappingURL=index45.js.map
